import React from 'react'
import Navigation from './components/Navigation'
import SideNav from './components/SideNav'
import Hero from './components/Hero'
import Intro from './components/Intro'
import MenuDetailSection from './components/MenuDetailSection'
import Gallery from './components/Gallery'
import VotedKeywords from './components/VotedKeywords'
import Reviews from './components/Reviews'
import Press from './components/Press'
import Footer from './components/Footer'
import StickyCTA from './components/StickyCTA'
import LocalIntentSection from './components/LocalIntentSection'
import { useCMS } from '../../context/CMSContext'
import { useLanguage } from '../../context/LanguageContext'
import '../../styles/components/restaurant.css'

const RestaurantPage: React.FC = () => {
    const { content, loading, error } = useCMS()
    const { language } = useLanguage()

    if (loading) {
        return (
            <div className="restaurant-page">
                <Navigation />
                <div className="flex items-center justify-center min-h-screen">
                    <div className="text-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600 mx-auto mb-4"></div>
                        <p className="text-gray-600">Loading content...</p>
                    </div>
                </div>
            </div>
        )
    }

    if (error) {
        return (
            <div className="restaurant-page">
                <Navigation />
                <div className="flex items-center justify-center min-h-screen">
                    <div className="text-center">
                        <p className="text-red-600 mb-4">Error loading content: {error}</p>
                        <button
                            onClick={() => window.location.reload()}
                            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                        >
                            Retry
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="restaurant-page">
            <Navigation />
            <SideNav />

            {content.hero && <Hero content={content.hero} />}
            {content.intro && <Intro content={content.intro} />}
            {content.menuDetail && <MenuDetailSection content={content.menuDetail} />}
            {content.gallery && <Gallery content={content.gallery} />}
            {content.votedKeywords && <VotedKeywords content={content.votedKeywords} />}
            {content.reviews && <Reviews content={content.reviews} />}
            {language === 'ko' && content.press && <Press content={content.press} />}
            <LocalIntentSection />
            {content.footer && <Footer content={content.footer} />}
            <StickyCTA />
        </div>
    )
}

export default RestaurantPage
